<div *ngIf="(isLoading | async) ?? false" class="loader">
    <img class="loader-progress" src="assets/svg/loader.svg" alt="LOADER">
</div>